import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import AttendanceAuditReportList from './AttendanceAuditReportList';

const AttendanceAuditReport = () => {
  return renderComponent(<AttendanceAuditReportList />);
};

export default AttendanceAuditReport;
